import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full px-2 first:pl-0 last:pr-0"
}
const _hoisted_2 = { class: "flex items-center gap-1" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "flex-1 rounded-xl border border-[#e7ddcc] py-1.5 text-center text-xs font-medium text-parameter-title" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "relative mt-4 flex h-4 items-center select-none" }
const _hoisted_7 = { class: "pointer-events-none absolute inset-x-0 h-[3px] rounded-full bg-[#e7ddcc]" }
const _hoisted_8 = ["max", "value"]
const _hoisted_9 = { class: "mt-1 flex justify-between text-[10px] text-parameter-text" }

import {computed, inject, ref, watch} from "vue";
import {useStore} from "vuex";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import ItemV3StonesParameterLoading from "@/components/itemV3/parameter/stones/parameter/itemV3StonesParameterLoading.vue";

const variantIdx = ""


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesStoneSize',
  props: {
    groupIdx: {}
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * session
 *
 * Transferred from itemV3StonePresetsStoneSize.vue: configureAll/itemIdx are wired into
 * ParametersVariations the same way, but - like itemV3StonesPosition.vue - the variant
 * is fetched per stone group via getItemVariants(itemIdx, "stones.<groupIdx>.stone_size")
 * instead of the fixed "stones.0.stone_size" used there.
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

/**
 * stone size - stones.<groupIdx>.stone_size
 */

const stoneSize = ref({
  "stone_size": {}
} as any)

const getStoneSizeData = (groupIdy: number) => {
  if (groupIdy >= 0) {
    stoneSize.value.stone_size = parametersVariations.getItemVariants(itemIdx.value, "stones." + groupIdy + ".stone_size")
  }
}

watch(() => props.groupIdx, (groupIdy) => {
  getStoneSizeData(groupIdy)
}, {immediate: true})

watch(session, () => {
  getStoneSizeData(props.groupIdx)
}, {deep: true})

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  value = (typeof value == "string") ? value : value.idx
  emit('patch', {
    action: actionIdx,
    value: value,
    certificated_diamond: value.certificated_diamond
  });
};

/**
 * stone size - step slider (transferred from itemV3Grooves.vue's "groove details - width")
 */

const sizeValues = computed(() => stoneSize.value.stone_size[0]?.values || [])

const sizeIdx = computed(() => {
  const idx = sizeValues.value.findIndex((v: any) => v.match)
  return idx === -1 ? 0 : idx
})

// local slider position, so dragging the handle only updates the UI - the api
// call is only sent once the user drops (releases) the slider, see onSizeRangeChange
const sliderSizeIdx = ref(0)

watch(sizeIdx, (idx) => {
  sliderSizeIdx.value = idx
}, {immediate: true})

const sizeSliderPercent = computed(() => {
  if (sizeValues.value.length < 2) return 0
  return (sliderSizeIdx.value / (sizeValues.value.length - 1)) * 100
})

const currentSize = computed(() => sizeValues.value[sliderSizeIdx.value])

const stepSize = (delta: number) => {
  if (!stoneSize.value.stone_size[0]) return
  const newIdx = sizeIdx.value + delta
  if (newIdx < 0 || newIdx >= sizeValues.value.length) return
  handleValuePatch(stoneSize.value.stone_size[0].idx, sizeValues.value[newIdx])
}

const onSizeRangeInput = (event: Event) => {
  sliderSizeIdx.value = parseInt((event.target as HTMLInputElement).value)
}

const onSizeRangeChange = (event: Event) => {
  if (!stoneSize.value.stone_size[0]) return
  const idx = parseInt((event.target as HTMLInputElement).value)
  const value = sizeValues.value[idx]
  if (value) handleValuePatch(stoneSize.value.stone_size[0].idx, value)
}


return (_ctx: any,_cache: any) => {
  return (stoneSize.value.stone_size[0])
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full border border-[#e7ddcc] text-[#8f8a80] transition-colors hover:bg-[#f3f0e9] hover:text-brand-main disabled:cursor-not-allowed disabled:opacity-30",
            disabled: sizeIdx.value <= 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (stepSize(-1)))
          }, " − ", 8, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(currentSize.value?.title), 1),
          _createElementVNode("button", {
            type: "button",
            class: "flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full border border-[#e7ddcc] text-[#8f8a80] transition-colors hover:bg-[#f3f0e9] hover:text-brand-main disabled:cursor-not-allowed disabled:opacity-30",
            disabled: sizeIdx.value >= sizeValues.value.length - 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (stepSize(1)))
          }, " + ", 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "h-full rounded-full bg-brand-main",
              style: _normalizeStyle({ width: sizeSliderPercent.value + '%' })
            }, null, 4)
          ]),
          _createElementVNode("div", {
            class: "pointer-events-none absolute top-1/2 size-4 rounded-full bg-brand-main shadow-md",
            style: _normalizeStyle({ left: sizeSliderPercent.value + '%', transform: 'translate(-50%, -50%)' })
          }, null, 4),
          _createElementVNode("input", {
            type: "range",
            class: "absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0",
            min: "0",
            max: sizeValues.value.length - 1,
            step: "1",
            value: sliderSizeIdx.value,
            onInput: onSizeRangeInput,
            onChange: onSizeRangeChange
          }, null, 40, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(sizeValues.value[0]?.title), 1),
          _createElementVNode("span", null, _toDisplayString(sizeValues.value[sizeValues.value.length - 1]?.title), 1)
        ])
      ]))
    : (_openBlock(), _createBlock(ItemV3StonesParameterLoading, { key: 1 }))
}
}

})